// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__34WyK","selects":"Documents_selects__2pKcT"};